var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1569_7428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.38226 0.00488281C1.95468 0.00488281 0 1.95956 0 4.38714V19.6227C0 22.0502 1.95468 24.0049 4.38226 24.0049H12.6398V14.6224H10.1588V11.2444H12.6398V8.35839C12.6398 6.09099 14.1057 4.00914 17.4825 4.00914C18.8497 4.00914 19.8608 4.1404 19.8608 4.1404L19.7813 7.29491C19.7813 7.29491 18.7501 7.28516 17.625 7.28516C16.4073 7.28516 16.212 7.84623 16.212 8.77767V11.2444H19.878L19.7183 14.6224H16.212V24.0049H19.6177C22.0453 24.0049 24 22.0503 24 19.6227V4.38716C24 1.95959 22.0453 0.00490681 19.6177 0.00490681H4.38223L4.38226 0.00488281Z",
    fill: "#131622"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1569_7428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00488281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBlack);
export default __webpack_public_path__ + "static/media/fbBlack.6f5c424e93bfcd14467fe55da0013b34.svg";
export { ForwardRef as ReactComponent };